export const PRODUCT = {
    ALL: 'all',
    RADAR: 'radar',
    STRATEGIZER: 'strategizer',
    TRENDMANAGER: 'trendmanager',
    TRENDEXPLORER: 'trendexplorer'
}
